import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"
import { find, last } from "lodash-es"

interface Signature {
  Element: HTMLDivElement
  Args: {
    entry: KbEntry
    parent: KbEntry
  }
}

export default class KbEntryComponent extends Component<Signature> {
  @service("ember-store") declare store: EmberStore

  @use children = new HasManyAltogether<KbEntry>(() => [this.args.entry, "children", "kb-entry"])
  @use ancestors = new HasManyAltogether<KbEntry>(() => [this.args.entry, "ancestors", "kb-entry"])

  @computed("ancestors.isFulfilled")
  get parent() {
    return last(this.ancestors.content)
  }

  @computed("ancestors.isFulfilled")
  get chapter(): KbEntry | undefined {
    return find(this.ancestors.content, (ancestor) => {
      return ancestor.meta.type === "chapter"
    })
  }

  _lastModelForEntry = null

  get modelForEntryChapter(): KbEntry | null {
    let type = this.args.entry.meta.type

    let ret
    if (type === "section") {
      ret = this.args.parent
    } else if (type === "chapter") {
      ret = this.args.entry
    } else if (type === "article-wrapper") {
      ret = this.chapter
    }
    if (ret !== undefined) {
      this._lastModelForEntry = ret
    }
    if (ret === undefined && this._lastModelForEntry !== null) {
      return this._lastModelForEntry
    }

    return ret
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Entry::Main": typeof KbEntryComponent
  }
}
